// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../index';

import { FilterPriceRangeFragmentDoc } from '../../fragments/filters/filterPriceRange.fragment.generated';
import { MoneyFragmentDoc } from '../../../../fragments/money.fragment.generated';
import { FilterWeddingRingStyleFragmentDoc } from '../../fragments/filters/filterWeddingRingStyle.fragment.generated';
import { FacetedContentProductLabelTranslationFragmentDoc } from '../../../../../../domain/product/useFacetedContent.generated';
import { FilterWeddingRingCategoryFragmentDoc } from '../../fragments/filters/filterWeddingRingCategory.fragment.generated';
import { MetalFilterFragmentDoc, MetalFilterMetalFragmentDoc } from '../../fragments/filters/metalFilter.fragment.generated';
export const WeddingRingFiltersFragmentDoc = `
    fragment weddingRingFilters on CatalogueWeddingRingFilters {
  price(input: {currency: $currency, country: $country}) {
    ...filterPriceRange
  }
  ringStyles {
    ...filterWeddingRingStyle
  }
  categories {
    ...filterWeddingRingCategory
  }
  primaryMetals {
    ...metalFilter
  }
}
    `;